// extracted by mini-css-extract-plugin
module.exports = {"bottomBar":"BottomBar_bottomBar__3V5cZ"};